import React, { useState } from "react";

export const Gallery = ({ images }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (img) => {
    setModalImage(img);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalImage(null);
  };

  if (!images || images.length === 0) {
    return <div className="text-center py-5">No images available.</div>;
  }

  return (
    <section id="gallery">
      <div className="gallery-header">
        <h2>Gallery</h2>
        <p>Some moments captured with our amazing team & events.</p>
      </div>

      {/* Grid Layout */}
      <div className="gallery-grid">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="gallery-item"
            onClick={() => openModal(img.image)}
          >
            <img src={img.image} alt={`Gallery ${idx + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal-overlay"
          onClick={closeModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
        >
          <img
            src={modalImage}
            alt="Zoomed"
            onClick={(e) => e.stopPropagation()} // prevent closing on image click
            style={{
              maxHeight: "90%",
              maxWidth: "90%",
              borderRadius: "10px",
              boxShadow: "0 0 30px rgba(0, 0, 0, 0.6)",
            }}
          />
        </div>
      )}
    </section>
  );
};
